export * from './workQueue.service';
import { WorkQueueService } from './workQueue.service';

export const APIS = [WorkQueueService];
